import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Remonte en haut de page au changement de route, ou défile vers l'ancre #section si présente. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      // Laisse le temps à la page de se monter avant de défiler vers l'ancre.
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1))
        if (el) el.scrollIntoView({ behavior: 'smooth' })
        else window.scrollTo({ top: 0 })
      })
      return
    }
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash])
  return null
}
